export default {
    topics: [
        {
            title: 'Execute',
            href: 'sm-sql-Execute.html',
            attributes: { 'data-id': 'sm-sql-Execute' },
            menu: { hasChildren: false },
            tocID: 'sm-sql-Execute-d66e1672',
            topics: [],
        },
    ],
};

